const getScannerTicketReferenceNumber = (scannerTicket) => {
  return `scanner-${scannerTicket?.reservation.id}-${scannerTicket?.id}`
}

export {getScannerTicketReferenceNumber}